import { FaPlus } from "react-icons/fa";
import PedidoDetalleItem from "./PedidoDetalleItem";

export default function PedidoProductos({
  detalles,
  productos,
  onAdd,
  onUpdate,
  onDelete,
  onBuscar,
  onSelectProducto,
}) {
  return (
    <section className="space-y-3">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-100">
          Productos
        </h3>

        <button
          type="button"
          onClick={onAdd}
          className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-emerald-500 text-emerald-400 hover:bg-emerald-500 hover:text-slate-900 transition text-sm"
        >
          <FaPlus />
          Agregar
        </button>
      </div>

      {/* Lista */}
      {detalles.length === 0 && (
        <p className="text-xs text-slate-500">
          No hay productos agregados aún.
        </p>
      )}

      <div className="space-y-3">
        {detalles.map((detalle, index) => (
          <PedidoDetalleItem
            key={index}
            detalle={detalle}
            index={index}
            productos={productos}
            onUpdate={onUpdate}
            onDelete={onDelete}
            onBuscar={onBuscar}
            onSelectProducto={onSelectProducto}
          />
        ))}
      </div>
    </section>
  );
}
